<template>
  <div class="mod-org__leave-employee">
    <!-- 查询框 -->
      <el-row class="search-box">
        <div class="search-box-left flex-grow">
          <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
            <el-form-item label="员工姓名：">
              <el-input v-model="dataForm.name" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item label="员工姓名：" v-show="false">
              <el-input v-model="dataForm.name" placeholder="请输入" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="getDataList(1)" type="primary">{{ $t('query') }}</el-button>
              <el-button @click="reset()">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
      <el-table
        v-loading="dataListLoading"
        :data="dataList"
        border
        style="width: 100%; max-width: 100%;">
        <template slot="empty">
          <img src="@/assets/img/good/noGood.png">
          <div>暂无数据</div>
        </template>
        <el-table-column type="index" label="序号" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="code" label="员工编号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="name" label="姓名" header-align="center" align="center"></el-table-column>
        <el-table-column prop="orgName" label="部门" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userName" label="账号" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column prop="resignTime" label="离职日期" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="recoveryHandle(scope.row)">恢复</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="getDataList">
      </el-pagination>
  </div>
</template>
<script>
export default {
  data () {
    return {
      dataListLoading: false,
      dataForm: {
        name: ''
      },
      dataList: [],
      // 分页
      page: 1,
      limit: 10,
      total: 0
    }
  },
  methods: {
    getDataList (page = this.page) {
      this.page = page
      if (this.dataListLoading) {
        return false
      }
      this.dataListLoading = true
      this.$http.post(`/front/consumer/custorg/resignedEmployeesByPage`, {
        page: page,
        limit: this.limit,
        companyId: this.$store.state.user.defaultCompanyId,
        ...this.dataForm
      })
        .then(({ data: res }) => {
          this.dataListLoading = false
          if (res.code !== 0) {
            return false
          }
          this.dataList = res.data.data || []
          this.total = res.data.count
        }).catch(() => {
          this.dataListLoading = false
        })
    },
    pageSizeChangeHandle (val) {
      this.limit = val
      this.getDataList(1)
    },
    reset () {
      this.dataForm.name = ''
      this.getDataList(1)
    },
    // 恢复员工
    recoveryHandle (row) {
      this.$confirm(`确认恢复 ${row.name}？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http.get(`/front/consumer/custorg/restoreResignedEmployees/${row.custId}`)
          .then(({ data: res }) => {
            if (res.code !== 0) {
              return false
            }
            this.$message.success(this.$t('prompt.success'))
            this.getDataList(1)
          }).catch(() => {})
      }).catch(() => {
      })
    }
  }
}
</script>
<style lang='scss' scoped>
// .mod-org__leave-employee{
// }
</style>
